// All site content — preserved verbatim from ign-services-alsace.fr
export const LOGO = "/logo-ign.png";

export const CONTACT = {
    phone: "0766916896",
    phoneDisplay: "07 66 91 68 96",
    email: "Services.alsace67@gmail.com",
    address: "32 allée de la Robertsau, 67000 Strasbourg",
    whatsapp:
        "https://wa.me/33766916896?text=Bonjour%2C%20je%20souhaite%20un%20devis%20pour%20une%20prestation%20de%20nettoyage.",
};

export const TOPBAR = "Qualité Française  ·  Exigence Terrain  ·  Résultats Visibles";

export const NAV_LINKS = [
    { id: "accueil", label: "Accueil" },
    { id: "apropos", label: "Qui sommes-nous" },
    { id: "services", label: "Services" },
    { id: "avant-apres", label: "Avant / Après" },
    { id: "avis", label: "Avis" },
    { id: "contact", label: "Contact" },
];

export const IMG = {
    hero: "https://images.unsplash.com/photo-1758565811178-6341e9999f48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwcHJpc3RpbmUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzUyNDUwNDR8MA&ixlib=rb-4.1.0&q=85",
    about: "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMGxvYmJ5JTIwY2xlYW58ZW58MHx8fHwxNzc1MjQ1MDUwfDA&ixlib=rb-4.1.0&q=85",
    strasbourg:
        "https://images.unsplash.com/photo-1761745716992-a2c177605bbb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxzdHJhc2JvdXJnJTIwYWxzYWNlJTIwYmVhdXRpZnVsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3NTI0NTA1MHww&ixlib=rb-4.1.0&q=85",
    manifesto:
        "https://images.unsplash.com/photo-1758193017781-e3aee6c3e359?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBvZmZpY2UlMjBsb2JieSUyMGNsZWFufGVufDB8fHx8MTc3NTI0NTA0NHww&ixlib=rb-4.1.0&q=85",
    diogene:
        "https://images.pexels.com/photos/6195288/pexels-photo-6195288.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    diogeneAfter:
        "https://images.pexels.com/photos/8146158/pexels-photo-8146158.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    deces: "https://images.unsplash.com/photo-1631049552057-403cdb8f0658?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=85",
    decesAfter:
        "https://images.unsplash.com/photo-1630699375896-60bf4bc1ef9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=85",
    disinfect:
        "https://images.unsplash.com/photo-1642649238366-9b560a5519b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmluZyUyMHRlYW0lMjBoYXptYXQlMjBwcm90ZWN0aXZlJTIwZXF1aXBtZW50fGVufDB8fHx8MTc4NDcyNTYwOXww&ixlib=rb-4.1.0&q=85",
};

export const HERO = {
    badge: "Nettoyage professionnel · Strasbourg · Alsace",
    statement: "Confiez-nous votre nettoyage. Exigez l'excellence.",
    titleLines: [
        "Entreprise d'hygiène et de",
        "nettoyage professionnel",
        "à Strasbourg et en Alsace.",
    ],
    subtitle:
        "IGN Services Alsace accompagne les professionnels et les particuliers dans l'entretien, la désinfection, la vitrerie et la remise en état de leurs espaces. Réactivité, discrétion et exigence : notre mission est simple, redonner de la valeur à vos locaux.",
    trust: ["Intervention 7j/7", "Réactivité immédiate", "Résultat irréprochable"],
};

export const ABOUT = {
    kicker: "Qui sommes-nous",
    title: ["L'exigence d'un responsable", "hygiène à votre service."],
    p1: "IGN Services Alsace est née d'une conviction simple : le nettoyage professionnel n'est pas un métier secondaire, c'est un métier d'exigence. Après avoir parcouru la France en tant que directeur de restaurant et responsable hygiène, notre fondateur a décidé de mettre son expertise terrain au service des professionnels et particuliers de Strasbourg et de toute l'Alsace.",
    quote: "Qui mieux qu'un responsable hygiène peut comprendre vos exigences ?",
    p2: "Chaque intervention est pensée avec la rigueur d'un audit professionnel. Nous ne nettoyons pas des lieux — nous redonnons de la valeur à ce que vous avez construit.",
    points: [
        "Ancien directeur de restaurant, expert en hygiène",
        "Audits terrain avec standards 100/100",
        "Process stricts et résultats mesurables",
        "Approche humaine et suivi personnalisé",
    ],
    stat: { value: "100/100", label: "Audit hygiène" },
};

export const DOMAINES = {
    kicker: "Savoir-faire",
    title: "Nos domaines d'intervention",
    intro: "IGN Services Alsace intervient aussi bien pour l'entretien courant que pour les interventions spécialisées. Nous accompagnons les professionnels et les particuliers avec le même niveau d'exigence, de discrétion et de qualité, quelle que soit la nature de la mission.",
    items: [
        { label: "Nettoyage professionnel", desc: "Entretien et nettoyage professionnel de vos locaux, pour les professionnels comme pour les particuliers. Selon vos espaces, l'intervention peut comprendre l'entretien des sols, des surfaces, des sanitaires, des espaces communs ainsi que le nettoyage en profondeur des zones concernées." },
        { label: "Entretien de bureaux", desc: "Maintenez des espaces de travail propres, accueillants et agréables au quotidien. Nos interventions peuvent comprendre l'entretien des sols, des surfaces, des sanitaires, des espaces communs, des postes de travail et la gestion des corbeilles." },
        { label: "Restaurants", desc: "Une prestation adaptée aux exigences du secteur de la restauration. Nous intervenons notamment sur les salles, les sols, les surfaces, les sanitaires ainsi que sur le dégraissage et l'entretien approfondi des zones nécessitant une hygiène renforcée." },
        { label: "Hôtels", desc: "Nous accompagnons les établissements hôteliers dans l'entretien de leurs chambres, parties communes, sanitaires et espaces d'accueil, avec une attention particulière portée aux détails et à l'image de l'établissement." },
        { label: "Cabinets médicaux", desc: "Entretien rigoureux des salles d'attente, cabinets, sols, sanitaires et surfaces fréquemment touchées. Les méthodes et produits utilisés sont adaptés au niveau d'hygiène attendu dans les environnements médicaux." },
        { label: "Commerces", desc: "Valorisez votre espace de vente grâce à un nettoyage professionnel des sols, vitrines, surfaces, cabines, réserves et zones d'accueil. L'intervention peut être organisée en dehors des horaires d'ouverture." },
        { label: "Copropriétés", desc: "Entretien régulier ou ponctuel des halls, escaliers, ascenseurs, couloirs, locaux communs et surfaces vitrées afin de préserver la propreté et l'image de la résidence." },
        { label: "Vitrerie", desc: "Nettoyage professionnel des vitres, baies vitrées, encadrements et surfaces vitrées accessibles, pour un résultat propre, lumineux et sans traces." },
        { label: "Nettoyage en profondeur", desc: "Une intervention complète destinée aux espaces nécessitant un entretien intensif. Nous traitons méthodiquement les sols, surfaces, sanitaires, cuisines, zones difficiles d'accès et salissures incrustées." },
        { label: "Désinfection", desc: "Traitement ciblé des surfaces et des points de contact afin de renforcer le niveau d'hygiène des locaux. Le protocole est adapté à la nature des lieux et aux besoins identifiés." },
        { label: "Décontamination", desc: "Intervention spécifique réalisée après évaluation de la situation afin de traiter les zones présentant un risque biologique ou sanitaire. Les méthodes employées sont adaptées au type de contamination rencontré." },
        { label: "Remise en état", desc: "Remise en propreté complète d'un logement ou d'un local après une période d'inoccupation, une dégradation, un déménagement ou avant une nouvelle utilisation." },
        { label: "Nettoyage après travaux", desc: "Élimination des poussières, traces, résidus et salissures laissés après des travaux de rénovation ou d'aménagement, afin de rendre les lieux propres et utilisables." },
        { label: "Nettoyage de fin de chantier", desc: "Nettoyage complet avant livraison d'un chantier : évacuation des résidus légers, dépoussiérage, lavage des sols, nettoyage des surfaces, vitres et équipements accessibles." },
        { label: "Débarras", desc: "Évacuation organisée des objets, meubles, encombrants et déchets autorisés, avec possibilité de compléter la prestation par un nettoyage approfondi des espaces libérés." },
        { label: "Syndrome de Diogène", to: "/nettoyage-syndrome-diogene-strasbourg", secondaryLabel: "Découvrir notre accompagnement", desc: "Une intervention discrète, respectueuse et sans jugement pour désencombrer, trier, débarrasser, nettoyer, désinfecter et remettre les lieux en état." },
        { label: "Nettoyage après décès", to: "/nettoyage-apres-deces-strasbourg", secondaryLabel: "En savoir plus", desc: "Une prise en charge professionnelle, humaine et confidentielle comprenant, selon la situation, le nettoyage, la désinfection, la décontamination et la désodorisation des lieux." },
        { label: "Désodorisation", desc: "Traitement des odeurs persistantes liées au tabac, aux animaux, à l'humidité, aux déchets ou à une forte insalubrité. La méthode est choisie en fonction de l'origine et de l'intensité des odeurs." },
        { label: "Entretien régulier", desc: "Mise en place d'un programme d'entretien adapté à vos locaux et à votre fréquence souhaitée : quotidienne, hebdomadaire ou personnalisée selon vos besoins." },
        { label: "Interventions ponctuelles", desc: "Une solution flexible pour répondre à un besoin précis : grand nettoyage, événement, déménagement, état des lieux, sinistre léger ou remise en propreté exceptionnelle." },
    ],
};

export const SERVICES = {
    kicker: "Nos services",
    title: "Des prestations d'excellence",
    intro: "Nettoyage professionnel, désinfection, vitrerie, remise en état — chaque service est exécuté avec la rigueur d'un audit professionnel à Strasbourg et dans toute l'Alsace.",
    cards: [
        {
            icon: "Building2",
            title: "Nettoyage de bureaux à Strasbourg",
            desc: "Entretien régulier de vos bureaux, espaces de travail et locaux professionnels à Strasbourg et en Alsace avec des standards élevés.",
            img: "https://static.prod-images.emergentagent.com/jobs/80949cf8-7823-4558-992a-75c4b013c9fa/images/113c7145e25e2c32a2a24a9d7ac0669ffa0cd2a38c377bdc13e0c138447721d3.jpeg",
            to: "/nettoyage-bureaux-strasbourg",
            cta: "Découvrir cette prestation",
        },
        {
            icon: "Paintbrush",
            title: "Remise en état à Strasbourg",
            desc: "Restauration complète de vos espaces après sinistre, déménagement ou usure. Résultat qui redonne toute leur valeur à vos locaux.",
            img: "https://images.unsplash.com/photo-1758448018619-4cbe2250b9ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiYXRocm9vbSUyMHNwb3RsZXNzJTIwbWFyYmxlfGVufDB8fHx8MTc3NTI0NTA0NHww&ixlib=rb-4.1.0&q=85",
            to: "/remise-en-etat-strasbourg",
            cta: "Découvrir cette prestation",
        },
        {
            icon: "Columns3",
            title: "Nettoyage après travaux en Alsace",
            desc: "Nettoyage fin de chantier minutieux pour livrer des espaces prêts à l'emploi, sans aucune trace de poussière ni de résidu.",
            img: "https://static.prod-images.emergentagent.com/jobs/80949cf8-7823-4558-992a-75c4b013c9fa/images/2e6d7a2fbb558136729300333f682222d93c0aa32ebc0b775201e4942d37f0b0.jpeg",
            to: "/nettoyage-fin-chantier-strasbourg",
            cta: "Découvrir cette prestation",
        },
        {
            icon: "Sparkles",
            title: "Vitrerie professionnelle à Strasbourg",
            desc: "Nettoyage de vitres, baies vitrées et vitrines. Une transparence parfaite qui valorise l'image de votre établissement.",
            img: "https://static.prod-images.emergentagent.com/jobs/80949cf8-7823-4558-992a-75c4b013c9fa/images/28a2d654ed01c3a986ed9c6a4e325f563fd07aeb2759ffe1628bbd024d603d68.jpeg",
            to: "/nettoyage-vitres-strasbourg",
            cta: "Découvrir cette prestation",
        },
        {
            icon: "TriangleAlert",
            title: "Interventions urgentes 7j/7",
            desc: "Disponibilité immédiate pour toutes vos urgences nettoyage et désinfection de locaux professionnels en Alsace.",
            img: "https://static.prod-images.emergentagent.com/jobs/80949cf8-7823-4558-992a-75c4b013c9fa/images/4c34e0d1212bf851f15ee05a40df204185627145fab78bff1489df46c21b39c2.jpeg",
        },
        {
            icon: "UtensilsCrossed",
            title: "Nettoyage restaurants en Alsace",
            desc: "Expertise nettoyage restauration avec les exigences HACCP et audit hygiène intégrés. Hôtels, brasseries, restaurants.",
            img: "https://static.prod-images.emergentagent.com/jobs/80949cf8-7823-4558-992a-75c4b013c9fa/images/11bd7b45a5486e57e30390e619085bbb454ce98db76be0318a3c2a21714a6d33.jpeg",
            to: "/nettoyage-restaurants-strasbourg",
            cta: "Découvrir cette prestation",
        },
        {
            icon: "ShieldAlert",
            title: "Nettoyage extrême & syndrome de Diogène",
            desc: "Intervention discrète, respectueuse et sans jugement dans les logements fortement encombrés ou insalubres. Prise en charge complète selon la situation : tri, débarras, évacuation des déchets, nettoyage approfondi, désinfection et désodorisation.",
            img: "https://images.pexels.com/photos/6195288/pexels-photo-6195288.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            to: "/nettoyage-syndrome-diogene-strasbourg",
            cta: "Découvrir cette prestation",
        },
        {
            icon: "HeartHandshake",
            title: "Nettoyage après décès",
            desc: "Intervention respectueuse et discrète pour le nettoyage, la désinfection et la remise en état des logements après un décès. Accompagnement bienveillant des familles et mandataires.",
            img: "https://images.unsplash.com/photo-1631049552057-403cdb8f0658?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=85",
            to: "/nettoyage-apres-deces-strasbourg",
            cta: "Découvrir cette prestation",
        },
        {
            icon: "GraduationCap",
            title: "Écoles & établissements scolaires",
            desc: "Entretien des salles de classe, espaces communs, sanitaires et zones de circulation, avec des protocoles adaptés aux établissements scolaires.",
            img: "https://images.unsplash.com/photo-1643199121319-b3b5695e4acb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzY2hvb2wlMjBjbGFzc3Jvb20lMjBjbGVhbiUyMGJyaWdodCUyMGludGVyaW9yfGVufDB8fHx8MTc4NjY2MTk5Nnww&ixlib=rb-4.1.0&q=85",
            to: "/nettoyage-ecoles-strasbourg",
            cta: "Découvrir cette prestation",
        },
        {
            icon: "Warehouse",
            title: "Entrepôts & plateformes logistiques",
            desc: "Nettoyage professionnel des sols, quais, zones de circulation, bureaux et espaces communs des sites logistiques.",
            img: "https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHdhcmVob3VzZSUyMGxvZ2lzdGljcyUyMGluZHVzdHJpYWwlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODY2NjE5OTZ8MA&ixlib=rb-4.1.0&q=85",
            to: "/nettoyage-entrepots-alsace",
            cta: "Découvrir cette prestation",
        },
    ],
};

export const WHY = {
    kicker: "Pourquoi nous choisir",
    title: "Ce qui fait notre différence",
    intro: "On ne nettoie pas des lieux, on redonne de la valeur.",
    cards: [
        { icon: "Target", title: "Exigence terrain", desc: "Nos standards viennent du terrain, pas d'un bureau. Chaque intervention est pensée comme un audit professionnel." },
        { icon: "Eye", title: "Suivi réel", desc: "Un interlocuteur unique, un contrôle qualité après chaque passage, et une totale transparence sur nos méthodes." },
        { icon: "Heart", title: "Approche humaine", desc: "Derrière chaque prestation, il y a des personnes formées, respectueuses de vos espaces et de vos contraintes." },
        { icon: "CheckCheck", title: "Résultat visible", desc: "La propreté se voit, se sent, se mesure. Nos résultats parlent d'eux-mêmes — nos clients aussi." },
    ],
    quote: "On ne nettoie pas des lieux, on redonne de la valeur.",
};

export const BEFORE_AFTER = {
    kicker: "Avant / Après",
    title: "La preuve par l'image",
    intro: "Nos résultats parlent d'eux-mêmes. Découvrez la transformation de nos interventions.",
    items: [
        {
            img: "/gallery/canape_avant_apres.jpg",
            title: "Nettoyage canapé",
            desc: "Canapé en tissu — résultat après un nettoyage en profondeur",
        },
        {
            img: "/gallery/faillance_avant_apres.jpg",
            title: "Nettoyage de la faïence murale d'une cuisine",
            desc: "Faïence murale de cuisine — les joints et surfaces retrouvent leur éclat",
        },
        {
            img: "/gallery/moquette_avant_apres.jpg",
            title: "Nettoyage moquette",
            desc: "Moquette très sollicitée — extraction profonde et résultat visible",
        },
    ],
};

export const ZONE = {
    kicker: "Zone d'intervention",
    title: ["Toute l'Alsace,", "avec Strasbourg au coeur."],
    intro: "Basés au coeur de Strasbourg, nous intervenons sur l'ensemble de l'Alsace pour du nettoyage professionnel, de la désinfection de locaux, de la vitrerie et de la remise en état. Notre réactivité nous permet d'être sur site rapidement, partout dans la région.",
    addressTitle: "Notre adresse",
    addressLines: ["32 allée de la Robertsau", "67000 Strasbourg"],
    cities: [
        "Strasbourg et agglomération",
        "Haguenau",
        "Molsheim",
        "Sélestat",
        "Obernai",
        "Saverne",
        "Colmar",
        "Tout le Bas-Rhin (67)",
    ],
    caption: "Strasbourg & toute l'Alsace",
    subcaption: "Intervention rapide • 7j/7 • Devis gratuit",
};

export const REVIEWS = {
    kicker: "Avis clients",
    title: "Ils nous font confiance",
    rating: "5,0 · 57 avis Google",
    google: {
        rating: "5,0",
        count: 57,
        label: "Note vérifiée sur Google",
        viewUrl: "https://www.google.com/maps?cid=17591966164799198049",
        writeUrl: "https://www.google.com/maps?cid=17591966164799198049",
    },
    testimonialsLabel: "Témoignages de nos clients",
    items: [
        { text: "Intervention rapide et résultat impeccable pour notre restaurant. L'équipe est très professionnelle, je recommande vivement.", name: "Marie D.", role: "Restaurant" },
        { text: "Remise en état complète de notre appartement après travaux. On ne reconnaît plus les lieux, c'est parfait !", name: "Thomas K.", role: "Particulier" },
        { text: "Nettoyage de nos bureaux chaque semaine. Toujours ponctuel, toujours impeccable. Une vraie tranquillité d'esprit.", name: "Sophie M.", role: "Entreprise" },
        { text: "Fin de chantier dans un immeuble neuf. Résultat irréprochable, les acquéreurs étaient ravis.", name: "Laurent B.", role: "Promoteur" },
        { text: "J'ai fait appel à eux pour mon canapé complètement taché. Le résultat avant/après est bluffant !", name: "Isabelle R.", role: "Particulier" },
        { text: "Hôtel 4 étoiles à Strasbourg. Nous leur confions le nettoyage des parties communes. Standard excellent.", name: "Jean-Marc P.", role: "Hôtellerie" },
    ],
};

export const MARQUEE = [
    "Nettoyage professionnel",
    "Désinfection",
    "Vitrerie",
    "Remise en état",
    "Débarras",
    "Entretien régulier",
    "Décontamination",
    "Résultats visibles",
];

export const FINAL_CTA = {
    line: "Votre espace mérite l'excellence.",
    button: "Obtenir mon devis",
    manifesto: "La propreté n'est pas une option. C'est une exigence.",
    slogan: "On redonne de la valeur à vos espaces.",
};

export const CONTACT_SECTION = {
    kicker: "Contact",
    title: ["Parlons de", "votre projet."],
    intro: "Devis gratuit et sans engagement. Nous vous répondons sous 24h maximum.",
    formTitle: "Demander un devis gratuit",
    services: [
        "Offre nouveau client –20 %",
        "Nettoyage professionnel",
        "Remise en état",
        "Fin de chantier",
        "Nettoyage de vitres",
        "Intervention urgente",
        "Nettoyage restauration",
        "Écoles & établissements scolaires",
        "Entrepôts & plateformes logistiques",
        "Autre",
    ],
};

export const SERVICE_PAGES = {
    diogene: {
        slug: "nettoyage-syndrome-diogene-strasbourg",
        anchor: "devis-diogene",
        metaTitle: "Nettoyage syndrome de Diogène à Strasbourg | IGN Services Alsace",
        heroImg: IMG.diogene,
        heroKicker: "Nettoyage extrême · Débarras · Désinfection",
        title: ["Nettoyage extrême et syndrome", "de Diogène à Strasbourg et en Alsace"],
        heroText:
            "IGN Services Alsace intervient avec discrétion, respect et sans jugement dans les logements fortement encombrés, dégradés ou devenus insalubres. Chaque situation étant différente, nous mettons en place une intervention adaptée aux besoins du logement et de ses occupants.",
        heroCta: "Demander un devis confidentiel",
        situationsTitle: "Une intervention adaptée à chaque situation",
        situations: [
            "Logement fortement encombré",
            "Accumulation importante d'objets ou de déchets",
            "Syndrome de Diogène",
            "Logement insalubre ou très dégradé",
            "Présence d'odeurs persistantes",
            "Intervention après une longue période d'inoccupation",
            "Remise en état avant vente, location ou restitution",
            "Intervention demandée par une famille, un propriétaire, un bailleur ou un professionnel",
        ],
        situationsNote:
            "Nous évaluons chaque situation avec attention afin de proposer une prestation réellement adaptée. Aucun jugement n'est porté sur l'état du logement ou sur la situation de la personne concernée.",
        prestationsTitle: "Une prise en charge complète du logement",
        prestations: [
            "Évaluation de la situation",
            "Tri des objets selon les consignes du client",
            "Mise en sacs et débarras",
            "Évacuation des déchets",
            "Transport vers une déchetterie ou une filière adaptée",
            "Nettoyage approfondi des sols et des surfaces",
            "Dégraissage et décrassage",
            "Nettoyage de la cuisine et des sanitaires",
            "Désinfection des surfaces et des points de contact",
            "Désodorisation du logement",
            "Nettoyage du mobilier conservé",
            "Remise en état générale des pièces",
            "Nettoyage de la vitrerie lorsque cela est demandé",
            "Possibilité d'intervention en plusieurs étapes selon l'ampleur du chantier",
        ],
        prestationsNote:
            "La prestation exacte dépend de l'état du logement, de son accessibilité, du volume à débarrasser et des demandes du client.",
        prestationsImg: IMG.diogeneAfter,
        stat: { value: "100%", label: "Prise en charge" },
        process: [
            "Prise de contact confidentielle",
            "Envoi de photos ou organisation d'une visite",
            "Évaluation du volume et des prestations nécessaires",
            "Transmission d'un devis clair et détaillé",
            "Organisation de l'intervention",
            "Tri, débarras et évacuation",
            "Nettoyage approfondi, désinfection et désodorisation",
            "Contrôle final du logement",
        ],
        processNote:
            "Selon la situation, l'intervention peut être organisée rapidement et réalisée en une ou plusieurs journées. Nous pouvons également intervenir en plusieurs phases afin de respecter les besoins de la personne concernée.",
        engagementsTitle: "Discrétion, respect et absence de jugement",
        engagementsText:
            "Les situations d'accumulation extrême ou de syndrome de Diogène peuvent être difficiles à vivre pour la personne concernée et pour son entourage. Nos équipes interviennent avec professionnalisme, discrétion et bienveillance. Les échanges restent confidentiels et l'intervention est organisée de manière à préserver au maximum la dignité et la tranquillité des occupants.",
        engagements: [
            "Intervention discrète",
            "Équipe professionnelle",
            "Respect des personnes et des lieux",
            "Aucun jugement",
            "Devis confidentiel",
            "Organisation adaptée à chaque situation",
        ],
        disinfectTitle: "Des protocoles adaptés à la désinfection et à la décontamination",
        disinfectText: [
            "Lorsque l'état du logement le nécessite, IGN Services Alsace réalise des opérations de désinfection et de décontamination selon des méthodologies et des protocoles adaptés à la situation rencontrée. Nos interventions sont effectuées avec du matériel professionnel ainsi que des produits spécifiquement dédiés au traitement des surfaces, des équipements, des points de contact et des zones présentant un risque sanitaire.",
            "Notre personnel est formé, expérimenté et habitué à intervenir dans des environnements fortement dégradés, insalubres ou contaminés. Chaque intervention est organisée avec rigueur afin de limiter les risques, de traiter les zones concernées et de restaurer un environnement aussi propre, sain et sécurisé que possible.",
            "Le protocole appliqué dépend de la nature des risques identifiés, de l'état du logement, des surfaces concernées et du niveau de contamination constaté. Les prestations réalisées sont clairement détaillées dans le devis transmis avant l'intervention.",
        ],
        disinfect: [
            "Personnel formé et expérimenté",
            "Méthodologies adaptées à chaque situation",
            "Protocoles professionnels d'intervention",
            "Matériel dédié à la désinfection et à la décontamination",
            "Produits professionnels adaptés aux surfaces traitées",
            "Port d'équipements de protection individuelle",
            "Traitement approfondi des zones sensibles",
            "Désinfection des surfaces et des points de contact",
            "Organisation rigoureuse et sécurisée de l'intervention",
            "Contrôle final après traitement",
        ],
        zoneText:
            "IGN Services Alsace intervient pour le nettoyage extrême et le débarras de logements insalubres dans l'ensemble du Bas-Rhin et du Haut-Rhin.",
        cities: ["Strasbourg", "Schiltigheim", "Illkirch-Graffenstaden", "Lingolsheim", "Bischheim", "Haguenau", "Saverne", "Sélestat", "Colmar", "Mulhouse"],
        faq: [
            { q: "Intervenez-vous réellement sans jugement ?", a: "Oui. L'intervention est réalisée avec respect, discrétion et professionnalisme, quelle que soit la situation du logement." },
            { q: "Est-il nécessaire d'être présent pendant l'intervention ?", a: "Non, cela dépend de la situation. Les modalités d'accès et les consignes peuvent être organisées à l'avance avec le client." },
            { q: "Pouvez-vous trier les objets avant de les jeter ?", a: "Oui. Le tri est effectué selon les consignes données par le client ou la famille. Les documents, souvenirs et objets importants peuvent être mis de côté." },
            { q: "Évacuez-vous les déchets et les meubles ?", a: "Oui, l'évacuation peut être intégrée au devis selon le volume, la nature des déchets et les éléments à retirer." },
            { q: "Pouvez-vous supprimer totalement les mauvaises odeurs ?", a: "Un nettoyage approfondi, une désinfection et une désodorisation permettent de réduire fortement les odeurs. Le résultat dépend toutefois de leur origine, de l'état des matériaux et de la durée pendant laquelle elles se sont installées." },
            { q: "Combien coûte une intervention pour un syndrome de Diogène ?", a: "Le tarif dépend notamment de la superficie, du niveau d'encombrement, du volume à évacuer, de l'insalubrité, de l'accessibilité et du nombre de journées nécessaires. Un devis personnalisé est établi après étude de la situation." },
            { q: "Pouvez-vous intervenir rapidement ?", a: "Oui, selon les disponibilités et le niveau d'urgence. Le client peut transmettre des photos afin de faciliter une première évaluation." },
        ],
        closingTitle: "Besoin d'une intervention discrète et rapide ?",
        closingText:
            "Expliquez-nous simplement la situation ou transmettez-nous quelques photos. Nous vous répondrons avec discrétion afin de vous proposer une solution adaptée.",
    },
    deces: {
        slug: "nettoyage-apres-deces-strasbourg",
        anchor: "devis-deces",
        metaTitle: "Nettoyage après décès à Strasbourg | IGN Services Alsace",
        heroImg: IMG.deces,
        heroKicker: "Respect · Dignité · Discrétion",
        title: ["Nettoyage après décès", "à Strasbourg et en Alsace"],
        heroText:
            "IGN Services Alsace intervient avec respect, dignité et discrétion pour le nettoyage, la désinfection et la remise en état des logements après un décès. Nous accompagnons les familles et les mandataires avec professionnalisme et bienveillance dans ces moments difficiles.",
        heroCta: "Demander un devis confidentiel",
        situationsTitle: "Une intervention adaptée à chaque situation",
        situations: [
            "Nettoyage du logement après un décès",
            "Découverte tardive nécessitant une intervention rapide",
            "Présence de fluides biologiques ou de déchets organiques",
            "Odeurs persistantes liées à la décomposition",
            "Logement nécessitant une désinfection complète",
            "Remise en état avant restitution, vente ou relocation",
            "Intervention demandée par la famille, un notaire, un bailleur ou un syndic",
            "Accompagnement des familles dans une situation difficile",
        ],
        situationsNote:
            "Chaque situation est unique. Nous adaptons notre intervention avec sensibilité et rigueur, en tenant compte des besoins de la famille et de l'état du logement.",
        prestationsTitle: "Une prise en charge complète et respectueuse",
        prestations: [
            "Évaluation confidentielle de la situation",
            "Retrait et évacuation des éléments souillés (literie, textiles, mobilier)",
            "Nettoyage approfondi des sols, murs et surfaces",
            "Traitement des fluides biologiques selon les protocoles adaptés",
            "Dégraissage et décrassage complet des pièces concernées",
            "Nettoyage de la cuisine et des sanitaires",
            "Désinfection complète des surfaces et des points de contact",
            "Désodorisation professionnelle du logement",
            "Traitement des odeurs persistantes",
            "Nettoyage du mobilier conservé",
            "Nettoyage de la vitrerie si nécessaire",
            "Remise en état générale du logement",
            "Évacuation des déchets vers les filières adaptées",
            "Possibilité d'intervention en plusieurs étapes selon la situation",
        ],
        prestationsNote:
            "Les prestations réalisées dépendent de l'état du logement, de la nature de la situation et des souhaits de la famille ou du mandataire.",
        prestationsImg: IMG.decesAfter,
        stat: { value: "24h", label: "Réponse rapide" },
        process: [
            "Prise de contact confidentielle avec la famille ou le mandataire",
            "Évaluation de la situation (photos ou visite sur place)",
            "Identification des prestations nécessaires",
            "Transmission d'un devis clair, détaillé et sans engagement",
            "Organisation de l'intervention en accord avec la famille",
            "Nettoyage, désinfection et désodorisation du logement",
            "Évacuation des éléments souillés et des déchets",
            "Contrôle final et remise du logement",
        ],
        processNote:
            "L'intervention peut être organisée rapidement selon l'urgence. Nous nous adaptons au calendrier de la famille et pouvons intervenir en plusieurs phases si nécessaire.",
        engagementsTitle: "Dignité, respect et accompagnement",
        engagementsText:
            "La perte d'un proche est une épreuve. Nous en sommes pleinement conscients. C'est pourquoi chaque intervention est réalisée avec le plus grand respect pour la mémoire du défunt et pour les sentiments de la famille. Nos équipes sont formées, sensibilisées et habituées à intervenir dans ces situations avec professionnalisme et humanité.",
        engagements: [
            "Respect de la mémoire du défunt",
            "Intervention discrète et confidentielle",
            "Équipe formée et sensibilisée",
            "Accompagnement bienveillant des familles",
            "Échanges et devis confidentiels",
            "Organisation adaptée au calendrier de la famille",
        ],
        disinfectTitle: "Des protocoles rigoureux adaptés aux risques biologiques",
        disinfectText: [
            "Après un décès, le logement peut présenter des risques sanitaires nécessitant une désinfection professionnelle. IGN Services Alsace applique des protocoles adaptés à chaque situation, avec du matériel dédié et des produits biocides professionnels conformes aux exigences de ce type d'intervention.",
            "Notre personnel est formé et expérimenté dans les interventions post-mortem. Chaque opération est organisée avec rigueur pour traiter les zones concernées et restaurer un environnement sain, propre et sécurisé.",
            "Le protocole mis en oeuvre dépend de la nature de la situation, de l'état du logement et des surfaces concernées. Les prestations sont détaillées dans le devis transmis avant toute intervention.",
        ],
        disinfect: [
            "Personnel formé aux interventions post-mortem",
            "Protocoles adaptés aux risques biologiques",
            "Produits biocides professionnels",
            "Équipements de protection individuelle",
            "Traitement des fluides biologiques",
            "Désinfection approfondie des zones concernées",
            "Désodorisation professionnelle",
            "Intervention sécurisée et rigoureuse",
            "Protocole détaillé dans le devis",
            "Contrôle final après traitement",
        ],
        zoneText:
            "IGN Services Alsace intervient pour le nettoyage après décès dans l'ensemble du Bas-Rhin et du Haut-Rhin.",
        cities: ["Strasbourg", "Schiltigheim", "Illkirch-Graffenstaden", "Lingolsheim", "Bischheim", "Haguenau", "Saverne", "Sélestat", "Colmar", "Mulhouse"],
        faq: [
            { q: "Intervenez-vous rapidement après un décès ?", a: "Oui. Selon les disponibilités et le niveau d'urgence, nous pouvons organiser une intervention rapide. La prise de contact est confidentielle et l'évaluation peut être réalisée à distance sur la base de photos." },
            { q: "L'intervention est-elle réalisée avec respect ?", a: "Absolument. Nos équipes sont formées et sensibilisées à ce type de situation. Chaque intervention est réalisée avec dignité, discrétion et bienveillance envers la famille et la mémoire du défunt." },
            { q: "Faut-il être présent pendant le nettoyage ?", a: "Non, ce n'est pas nécessaire. Les modalités d'accès et les consignes peuvent être convenues à l'avance. Nous comprenons que la présence sur les lieux peut être difficile pour les proches." },
            { q: "Pouvez-vous intervenir si le décès n'a été découvert que tardivement ?", a: "Oui. Nous sommes équipés et formés pour intervenir dans des situations de découverte tardive nécessitant un nettoyage approfondi, une désinfection et une désodorisation complètes." },
            { q: "Prenez-vous en charge l'évacuation du mobilier souillé ?", a: "Oui, l'évacuation des éléments souillés (literie, textiles, mobilier) peut être intégrée à la prestation. Le détail est précisé dans le devis." },
            { q: "Les odeurs peuvent-elles être totalement éliminées ?", a: "Un nettoyage approfondi, une désinfection et une désodorisation professionnelle permettent de réduire très fortement les odeurs. Le résultat final dépend de l'ampleur de la situation, des matériaux et de la durée d'exposition." },
            { q: "Combien coûte un nettoyage après décès ?", a: "Le tarif varie selon la superficie du logement, l'ampleur de la situation, les prestations nécessaires et le nombre de journées d'intervention. Un devis personnalisé et confidentiel est établi après évaluation." },
            { q: "Qui peut demander l'intervention ?", a: "La demande peut être faite par la famille du défunt, un notaire, un bailleur, un syndic de copropriété, un gestionnaire immobilier ou toute personne mandatée pour la gestion du logement." },
        ],
        closingTitle: "Besoin d'une intervention respectueuse et rapide ?",
        closingText:
            "Expliquez-nous simplement la situation. Nous vous répondrons avec discrétion et bienveillance afin de vous proposer une intervention adaptée.",
    },
};

export const EXCELLENCE = {
    kicker: "Notre engagement",
    title: "L'excellence, au prix juste.",
    intro: [
        "Chez IGN Services Alsace, l'excellence ne doit pas être inaccessible. Chaque intervention est réalisée avec exigence, précision et souci du détail, afin d'offrir un résultat réellement visible, durable et à la hauteur de vos attentes.",
        "Notre engagement : vous proposer un niveau de qualité premium avec des tarifs justes, transparents et adaptés à vos besoins réels.",
    ],
    engagements: [
        {
            icon: "Sparkles",
            title: "Des solutions professionnelles reconnues",
            text: "IGN Services Alsace utilise exclusivement des solutions professionnelles développées par un acteur mondialement reconnu dans les domaines de l'hygiène, du nettoyage et de la prévention des infections. Utilisées dans des environnements professionnels exigeants, notamment l'hôtellerie, la restauration, la santé et l'industrie, ces solutions nous permettent d'adapter chaque protocole à la surface traitée, de maîtriser précisément les dosages et de respecter les temps d'action recommandés.",
            chips: [
                "Solutions professionnelles reconnues",
                "Dosages et protocoles maîtrisés",
                "Exigence professionnelle, résultat visible",
            ],
            strong: "Des solutions reconnues mondialement. Un savoir-faire local. Une exigence sans compromis.",
        },
        {
            icon: "Droplets",
            title: "Une démarche responsable, sans compromis sur l'hygiène",
            text: "Notre démarche environnementale repose sur des actions concrètes : dosages rigoureusement maîtrisés, utilisation raisonnée de l'eau, réduction du gaspillage et sélection de solutions professionnelles adaptées à chaque intervention. Nos protocoles sont conçus pour garantir une efficacité optimale tout en évitant toute consommation excessive de produit ou de ressources. La sécurité sanitaire, la prévention des contaminations croisées et la qualité du résultat restent toujours prioritaires.",
        },
        {
            icon: "BadgeEuro",
            title: "Une qualité premium, des tarifs maîtrisés",
            text: "Notre exigence se retrouve dans chaque détail, pas dans des tarifs excessifs. Nous construisons des offres claires et adaptées aux besoins réels de chaque client, sans compromis sur la qualité de l'intervention.",
            strong: "Un résultat d'excellence. Un tarif juste. Une prestation sans compromis.",
        },
    ],
    offer: {
        badge: "Offre de bienvenue",
        title: "–20 % sur votre première intervention",
        subtitle: "Une offre de bienvenue réservée aux nouveaux clients d'IGN Services Alsace.",
        button: "Profiter de mon offre de bienvenue",
        service: "Offre nouveau client –20 %",
        conditions:
            "Offre réservée aux nouveaux clients et applicable sur une première intervention éligible. Hors contrats, abonnements, prestations déjà remisées, nettoyage après décès, syndrome de Diogène et interventions nécessitant des moyens exceptionnels. Offre non cumulable. Conditions définitives précisées sur le devis.",
    },
};

export const SITE = {
    url: "https://ign-services-alsace.fr",
    name: "IGN Services Alsace",
    phoneIntl: "+33766916896",
    email: "Services.alsace67@gmail.com",
    geo: { lat: 48.5951, lng: 7.7789 },
    sameAs: ["https://www.google.com/maps?cid=17591966164799198049"],
    rating: "5.0",
    reviewCount: "57",
    priceRange: "€€",
    areaServed: [
        "Strasbourg", "Haguenau", "Molsheim", "Sélestat", "Obernai",
        "Saverne", "Colmar", "Bas-Rhin", "Haut-Rhin", "Alsace",
    ],
};
